module.exports = {
  'en': {
    'HRMS19X1': {
      '10': 'Time Attendance Report',
      '20': 'Employee Code',
      '30': 'or Department',
      '40': 'Group of Emp.',
      '50': 'From',
      '60': 'To'
    },
    'HRMS19X2': {
      '10': 'Time Attendance Report',
      '20': 'During Date',
      '30': 'Employee Code',
      '40': 'Group',
      '60': 'Date',
      '80': 'Day',
      '90': 'Shift',
      '100': 'Schedule Time',
      '110': 'In',
      '120': 'Out',
      '130': 'Actual Time',
      '140': 'In',
      '150': 'Out',
      '160': 'Leave Description /',
      '170': 'Leave',
      '180': 'Abnormal (H:M)',
      '190': 'Late',
      '200': 'Early',
      '210': 'Absence',
      '280': 'Reasons of Adjust',
      '300': 'Overtime (H:M)',
      '310': 'Before',
      '320': 'During',
      '330': 'After',
      '340': 'Total'
    },
    'HRMS19XC1': {
      '10': 'Employee Code',
      '20': 'or Department',
      '25': 'Department',
      '30': 'Group Code',
      '40': 'Date From',
      '50': 'To Date',
      '60': 'Emp. Code',
      '70': 'Title',
      '71': 'Name - Surname',
      '72': 'Position',
      '73': 'Department',
      '80': 'Date From',
      '90': 'To Date',
      '100': 'Date',
      '110': 'Day',
      '120': 'Shift',
      '130': 'Schedule Time',
      '140': 'In',
      '150': 'Out',
      '160': 'Actual Time',
      '170': 'In',
      '180': 'Out',
      '190': 'Abnormal (H:M)',
      '200': 'Late',
      '210': 'Early',
      '220': 'Absence',
      '230': 'Leave Description /',
      '240': 'Reasons of Adjust',
      '250': 'Leave',
      '260': 'Overtime (H:M)',
      '270': 'Before',
      '280': 'During',
      '290': 'After',
      '300': 'Total',
      '310': 'Detail of Time Record'
    }
  },
  'th': {
    'HRMS19X1': {
      '10': 'รายละเอียดการมาปฏิบัติงานของพนักงาน',
      '20': 'รหัสพนักงาน',
      '30': 'หรือ หน่วยงาน',
      '40': 'กลุ่มพนักงาน',
      '50': 'จาก',
      '60': 'ถึง'
    },
    'HRMS19X2': {
      '10': 'รายละเอียดการมาปฏิบัติงานของพนักงาน',
      '20': 'ระหว่างวันที่',
      '30': 'รหัสพนักงาน',
      '40': 'กลุ่มพนักงาน',
      '60': 'วันที่',
      '80': 'วัน',
      '90': 'กะ',
      '100': 'เวลาที่กำหนด',
      '110': 'เข้า',
      '120': 'ออก',
      '130': 'เวลาทำงานจริง',
      '140': 'เข้า',
      '150': 'ออก',
      '160': 'รายละเอียดการลา',
      '170': 'การลา',
      '180': 'ความผิดปกติ(ชม:นาที)',
      '190': 'สาย',
      '200': 'กลับก่อน',
      '210': 'ขาดงาน',
      '280': 'สาเหตุการแก้ไขเวลา',
      '300': 'ล่วงเวลา (ชม:นาที)',
      '310': 'ก่อน',
      '320': 'ระหว่าง',
      '330': 'หลัง',
      '340': 'รวม'
    },
    'HRMS19XC1': {
      '10': 'รหัสพนักงาน',
      '20': 'หรือ หน่วยงาน',
      '25': 'หน่วยงาน',
      '30': 'กลุ่มพนักงาน',
      '40': 'ตั้งแต่วันที่',
      '50': 'ถึงวันที่',
      '60': 'รหัสพนักงาน',
      '70': 'คำนำหน้า',
      '71': 'ชื่อ - นามสกุล',
      '72': 'ตำแหน่ง',
      '73': 'หน่วยงาน',
      '80': 'ตั้งแต่วันที่',
      '90': 'ถึงวันที่',
      '100': 'วันที่',
      '110': 'วัน',
      '120': 'กะ',
      '130': 'เวลาที่กำหนด',
      '140': 'เข้า',
      '150': 'ออก',
      '160': 'เวลาทำงานจริง',
      '170': 'เข้า',
      '180': 'ออก',
      '190': 'ความผิดปกติ(ชม:นาที)',
      '200': 'สาย',
      '210': 'กลับก่อน',
      '220': 'ขาดงาน',
      '230': 'รายละเอียดการลา',
      '240': 'สาเหตุการแก้ไขเวลา',
      '250': 'การลา',
      '260': 'ล่วงเวลา (ชม:นาที)',
      '270': 'ก่อน',
      '280': 'ระหว่าง',
      '290': 'หลัง',
      '300': 'รวม',
      '310': 'รายละเอียดการรูดบัตร'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms19x.js